import { usePostHog } from "posthog-js/react";
import { useEffect, useState } from "react";

let userKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY ?? "";
userKey = `ph_${userKey}_posthog`;

export default function useAnalytics() {
  const posthog = usePostHog();
  const [userData, setUserData] = useState(
    JSON.parse(localStorage.getItem(userKey || "aiiro-user") || "{}")
  );

  useEffect(() => {
    posthog.group("company", window.companyId ? window.companyId : "");

    function getUser() {
      const user = localStorage.getItem(userKey ?? "aiiro-user");
      return user ? JSON.parse(user) : null;
    }

    setUserData(getUser());
  }, [posthog]);

  function captureEvent(event, properties = {}) {
    const payload = { ...properties, companyId: window.companyId };
    posthog?.capture(event, payload);
  }

  return { captureEvent, userData };
}
